import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { ENV } from "@app/constants/env";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: ENV.BASE_API_URL +ENV.LOGIN_APIURL,
});


export interface ApiResponse<T> {
  success: boolean
  message?: string
  data?: T
  error?: string
}
export const trackingpodApi = createApi({
  reducerPath: 'trackandtracesliceApi',
  baseQuery: rawBaseQuery,
  tagTypes: ['login'],
  endpoints: (builder) => ({

    trackandTracePOD: builder.query<ApiResponse<any>, string>({
        query: (invoiceNo) => ({
            url: `/TrackandTrace/TrackandTracePOD/${invoiceNo}`,
            method: 'GET',
        }),
        providesTags: ['login'],
    })

  }),
});

export const { 
  useTrackandTracePODQuery,

    } = trackingpodApi;
